var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TelemetryEventBaseOverlay',[_c('hr',{staticClass:"m-0 mb-4"}),_c('div',{staticClass:"data d-flex justify-content-around align-items-center"},[_c('span',{staticClass:"data"},[_vm._v("- "+_vm._s(_vm.unit_currency(_vm.eventRawData.tollgate.amount)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }